// @ts-nocheck
import React from 'react';
import logo from 'assets/img/login-logo.png';
import { Box, CircularProgress, Typography, useTheme } from '@mui/material';
import { ApprovedIcon } from 'pages/ProjectBudget/DayworkDocket/common/SvgIcons';
import PropTypes from 'prop-types';
import { useClientStyles } from '../../Styles';
import MarketingBanner from '../MarketingBanner';
import PreviewPdf from '../../PreviewPdf/PreviewPdf';
import MuiButton from 'components/__v5__/Button/MuiButton';
import useClientAccessDaywork from '../../hooks/useClientAccessDaywork';

const ApprovedModule = ({ approvalMessage }) => {
  const theme = useTheme();
  const classes = useClientStyles();
  const {
    pdfDataLoading,
    pdfData,
    onDownloadPdf,
    downloadLoadingPdf,
    pdf,
    openModal,
    setOpenModal,
  } = useClientAccessDaywork();
  return (
    <>
      <Box sx={{ width: { xs: '130px', sm: '164px' } }}>
        <img className="logo" src={logo} alt="Logo" />
      </Box>
      <Box
        className={classes.actionCard}
        sx={{
          width: { xs: 'auto', sm: '765px' },
        }}
        px={{ xs: 3, sm: 5 }}
        py={{ xs: 3, sm: 5 }}
      >
        <Box display="flex" alignItems="center" justifyContent="center" mb={1}>
          <ApprovedIcon />
        </Box>

        <Typography
          variant="h4"
          align="center"
          sx={{ color: theme.palette.success.light }}
        >
          Completed!
        </Typography>
        <Typography variant="body1" align="center" mt={{ xs: 2, sm: 3 }}>
          {approvalMessage}
        </Typography>
        <Typography variant="body1" align="center" mt={{ xs: 2, sm: 3 }}>
          <strong>Note: </strong> This link will no longer be active since you
          have approved the daywork.
        </Typography>
        <Box display="flex" alignItems="center" justifyContent="center" mt={2}>
          <MuiButton
            color="primary"
            variant="contained"
            size="small"
            onClick={onDownloadPdf}
            endIcon={
              downloadLoadingPdf && (
                <CircularProgress size={15} color="inherit" />
              )
            }
            disabled={downloadLoadingPdf}
          >
            Preview Report
          </MuiButton>

          <PreviewPdf
            open={openModal}
            setOpen={setOpenModal}
            downloadLoadingPdf={downloadLoadingPdf}
            pdf={pdf}
          />
        </Box>
      </Box>

      <MarketingBanner />
    </>
  );
};

export default ApprovedModule;

ApprovedModule.propTypes = {
  approvalMessage: PropTypes.string.isRequired,
};
